import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminHeader } from '../components/layout/AdminHeader';
import { AdminSidebar } from '../components/layout/AdminSidebar';
import { RouteErrorBoundary } from '../components/ErrorBoundary';
import { PageLoader } from '../components/SuspenseFallback';
import { SkipToContent } from '../utils/accessibility';

/** Ink column 236px + content `1fr` on surface (README handoff, Admin mocks). */
export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-surface lg:grid lg:grid-cols-[236px_1fr]">
      <SkipToContent />
      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex min-h-screen min-w-0 flex-col">
        <AdminHeader onMenuClick={() => setSidebarOpen(true)} />
        <main id="main-content" className="min-w-0 flex-1 px-4 py-8 md:px-9">
          <RouteErrorBoundary>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
